(function () {
  const items = document.querySelectorAll('.melalight-faq__item');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  items.forEach((item) => {
    const summary = item.querySelector('.melalight-faq__question');
    const answerWrap = item.querySelector('.melalight-faq__answer-wrap');
    if (!summary || !answerWrap) return;

    if (item.hasAttribute('open')) {
      item.classList.add('is-expanded');
    }

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      const isExpanded = item.classList.contains('is-expanded');

      if (isExpanded) {
        closeItem(item, answerWrap);
      } else {
        openItem(item);
      }
    });
  });

  function openItem(item) {
    item.setAttribute('open', '');

    if (prefersReducedMotion) {
      item.classList.add('is-expanded');
      return;
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        item.classList.add('is-expanded');
      });
    });
  }

  function closeItem(item, answerWrap) {
    if (prefersReducedMotion) {
      item.classList.remove('is-expanded');
      item.removeAttribute('open');
      return;
    }

    item.classList.remove('is-expanded');

    const handleTransitionEnd = (event) => {
      if (event.target !== answerWrap || event.propertyName !== 'grid-template-rows') {
        return;
      }

      answerWrap.removeEventListener('transitionend', handleTransitionEnd);
      item.removeAttribute('open');
    };

    answerWrap.addEventListener('transitionend', handleTransitionEnd);
  }
})();
